import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-pause",
  "use": "icon-pause-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-pause\"><path d=\"M243.512195 196.308293h99.902439v624.390244h-99.902439zM693.073171 196.308293h99.902439v624.390244h-99.902439z\" p-id=\"1984\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol